import { lazy } from 'react';

export const HeroShowsLazy = lazy(() => import('./HeroShows'));
